document.addEventListener('DOMContentLoaded', function () {
 const insertWishlistButtons = () => {
   const thumbnails = document.querySelectorAll('.product__media-item, .media-gallery__image');
   const referenceButton = document.querySelector('.swym-button, .swym-button-overlay');
   if (!referenceButton || thumbnails.length < 2) return;

   thumbnails.forEach((item, index) => {
     if (index === 0) return; // 1枚目は既にあるのでスキップ
     if (item.querySelector('.swym-button-overlay')) return; // すでにボタンがある場合

     const clone = referenceButton.cloneNode(true);
     item.style.position = 'relative';
     clone.style.position = 'absolute';
     clone.style.top = '10px';
     clone.style.right = '10px';
     clone.style.zIndex = '99';
     item.appendChild(clone);
   });
 };

 insertWishlistButtons();
 const observerTarget = document.querySelector('.product__media-list, .media-gallery__image');
 if (observerTarget) {
   new MutationObserver(insertWishlistButtons).observe(observerTarget, { childList: true, subtree: true });
 }
});

